import React, { useRef } from "react";
import styled from "styled-components/macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { uploadFiles } from "../Printer/printerHelper";

const UnitTool = ({
	onLogoChange,
	onRoomSimulationChange,
	onColorClick,
	ride,
	onRideSimulationChange,
	buildingName,
}) => {
	const inputRef = useRef();
	const [activeColor, SetActiveColor] = React.useState();

	return (
		<Wrapper>
			<Section>
				<AddLogoWrapper>
					<FontAwesomeIcon size={"xs"} color={"#707070"} icon={faPlus} />
					<UploadFileInput
						ref={inputRef}
						onChange={async (event) => {
							const url = await uploadFiles(
								event.target.files[0],
								buildingName,
								"logo"
							);
							onLogoChange(url);
						}}
						type="file"
					/>
				</AddLogoWrapper>
				<Title>{"Your Logo"}</Title>
			</Section>

			<Section>
				<AddLogoWrapper>
					<FontAwesomeIcon size={"xs"} color={"#707070"} icon={faPlus} />
					<UploadFileInput
						ref={inputRef}
						onChange={async (event) => {
							console.log("object", event.target.files[0]);
							const url = await uploadFiles(
								event.target.files[0],
								buildingName,
								"roomSim"
							);
							onRoomSimulationChange(url);

							// console.log(event.target.files[0])
							// singleFileUploadHandler(file, "operation_upload_printer_files", (url)=> console.log(url))
						}}
						type="file"
					/>
				</AddLogoWrapper>
				<Title>{"Unit simulation"}</Title>
			</Section>

			{ride && (
				<Section>
					<AddLogoWrapper>
						<FontAwesomeIcon size={"xs"} color={"#707070"} icon={faPlus} />
						<UploadFileInput
							ref={inputRef}
							onChange={async (event) => {
								const url = await uploadFiles(
									event.target.files[0],
									buildingName,
									"rideSim"
								);
								onRideSimulationChange(url);

								// console.log(event.target.files[0])
								// singleFileUploadHandler(file, "operation_upload_printer_files", (url)=> console.log(url))
							}}
							type="file"
						/>
					</AddLogoWrapper>
					<Title>{"Ride simulation"}</Title>
				</Section>
			)}
			<div
				style={{
					width: "10px",
					// backgroundColor: "#dcdcdc"
				}}
			/>
			<div
				style={{
					width: "10px",
					// backgroundColor: "#dcdcdc"
				}}
			/>
			<Section>
				<div style={{ display: "flex", flexDirection: "row" }}>
					<Color
						onClick={() => {
							onColorClick("linear-gradient(to bottom, #f7f7f7, #f1efef)");
							SetActiveColor("White");
						}}
						style={{ marginBottom: "10px" }}
						color={"#FFFFFF"}
						borderColor={"#707070"}
						active={activeColor === "White"}
					/>

					<div style={{ width: "5px", height: "100%" }} />

					<Color
						onClick={() => {
							onColorClick("linear-gradient(to bottom, #332c2c, #606060)");
							SetActiveColor("Black");
						}}
						/* style={{ marginBottom: "10px" }} */
						color={"#707070"}
						borderColor={"#707070"}
						active={activeColor === "Black"}
					/>

					{/* <div style={{ width: "5px", height: "100%" }} /> */}
				</div>
				<Title>{"Unit color"}</Title>
			</Section>
		</Wrapper>
	);
};

const Wrapper = styled.div`
	display: flex;
	color: #707070;
	position: relative;
	flex-direction: row;
	justify-content: center;
`;

const Color = styled.div`
	display: flex;
	width: 26px;
	height: 26px;
	cursor: pointer;
	position: relative;
	border-radius: 50%;
	background-color: ${({ color }) => color};
	border: 1px solid
		${({ borderColor, active }) => (active ? "#13647b" : borderColor)};
	transition: transform 300ms ease;
	transform: ${(props) => (props.active ? "scale(1.2)" : "scale(1)")};
`;

const AddLogoWrapper = styled.div`
	cursor: pointer;
	width: 20px;
	height: 20px;
	border-radius: 6px;
	border: 2px solid #707070;
	display: flex;
	position: relative;
	align-items: center;
	justify-content: center;
`;

const Section = styled.div`
	display: flex;
	position: relative;
	flex-direction: row;
	//padding: 10px;
	width: 100%;
	align-items: center;
	gap: 10px;
`;

const Title = styled.div`
	color: #707070;
	font-size: 14px;
	white-space: pre-wrap;
	text-align: center;
	font-family: Manrope, serif;
`;

const UploadFileInput = styled.input`
	cursor: pointer;
	font-size: 1px;
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	top: 0;
	opacity: 0;
	z-index: 9999;
`;
export { UnitTool };
